import { Routes } from '@angular/router';

export const ROUTES: Routes = [

  {
    path: '',
    loadComponent: () => import('./core/layout/layout.component').then(c => c.LayoutComponent),
    children: [
      {
        path: 'directory',
        loadComponent: () => import('./features/directory/directory.component').then(c => c.DirectoryComponent),
        loadChildren: () => import('./features/directory/directory-routing').then(r => r.DIRECTORY_ROUTES)
      },
      {
        path: '**',
        redirectTo: '/directory'
      }
    ]
  },

];
